<template>
    <div class="card-body">
        <div v-for="(post, index) in posts" :key="post.id">
            <div class="row">
                <div class="col-auto">
                    <a :href="root.url('post_view', { slug: post.slug, id: post.id })" class="avatar avatar-lg avatar-4by3">
                        <img :src="post.image ? post.image.sizes.small : root.asset('bundles/ornweb/img/no-thumbnail.png')" :alt="post.title" class="avatar-img rounded">
                    </a>
                </div>
                <div class="col ml-n2">
                    <h4 class="card-title mb-1">
                        <a :href="root.url('post_view', { slug: post.slug, id: post.id })" class="name text-dark">{{ post.title }}</a>
                    </h4>
                    <p class="text-muted mb-0 small">
                        <span v-if="post.author"><post-author :author="post.author"></post-author> &middot;</span>
                        <time :datetime="root.moment(post.publish_at).format('YYYY-MM-DD HH:mm:ss')">{{ root.moment(post.publish_at).fromNow() }}</time>
                    </p>
                </div>
            </div>
            <hr v-if="index < posts.length - 1" />
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue'
import PostAuthor from './PostAuthor.vue'

const props = defineProps({
    posts: {
        type: Array,
        required: true
    }
})

const root = inject('root')
</script>

<style scoped>
</style>